'use client';
import MuiDrawer, { DrawerProps } from '@mui/material/Drawer';

export function Drawer(props: DrawerProps) {
  return <MuiDrawer {...props} />;
}
